import { render } from "./DropdownItem.vue?vue&type=template&id=26f8ca42"
const script = {}

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__